module.exports = __webpack_public_path__ + "img/british-indian-ocean-territory.130668f7.svg";